import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { usePermissions } from '../../hooks/usePermissions';

interface PermissionRouteProps {
  /**
   * Cu00f3digo del permiso requerido
   */
  permission?: string;
  
  /**
   * Lista de permisos donde al menos uno es requerido
   */
  anyPermissions?: string[];
  
  /**
   * Lista de permisos donde todos son requeridos
   */
  allPermissions?: string[];
  
  /**
   * Ruta a la que redirigir si no tiene permiso
   */
  redirectTo?: string;
}

/**
 * Componente para proteger rutas basado en permisos del usuario
 */
const PermissionRoute: React.FC<PermissionRouteProps> = ({
  permission,
  anyPermissions,
  allPermissions,
  redirectTo = '/dashboard',
}) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions({});
  
  // Si no estu00e1 autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Verificar permisos segu00fan los props proporcionados
  let hasAccess = false;
  
  if (permission) {
    hasAccess = hasPermission(permission);
  } else if (anyPermissions?.length) {
    hasAccess = hasAnyPermission(anyPermissions);
  } else if (allPermissions?.length) {
    hasAccess = hasAllPermissions(allPermissions);
  } else {
    // Si no se especifican permisos, permitir acceso
    hasAccess = true;
  }
  
  // Renderizar la ruta o redirigir si no tiene permiso
  return hasAccess ? <Outlet /> : <Navigate to={redirectTo} replace />;
};

export default PermissionRoute; 